




























import { Component, Prop, Vue } from "vue-property-decorator";
import { apiService, Interfaces, AppConstants, Models } from "@/core/Export";
import AdditionList from "./AdditionList.vue";
import AddEditAddition from "./AddEditAddition.vue";
import store from "@/store";
@Component({
  components: { AdditionList, AddEditAddition },
})
export default class AdditionDrawerForm extends Vue {
  @Prop() isFromEmpAttend: boolean;
  @Prop() attendModel;
  model: Models.EmployeeExtra = new Models.EmployeeExtra();
  employeeDayAdditionalReason: Array<any>;
  hourTypes: Array<any>;
  editMode: string;
  canAddItem: boolean;
  isCurrentUserAdditional: boolean;
  employeePortalMinDto: any;
  isReady: boolean = false;

  constructor() {
    super();
    this.editMode = "viewList";
    this.model.employeeId = this.drawerParams.employeeId;
    this.canAddItem = false;
    this.isCurrentUserAdditional = this.drawerParams.isCurrentUserAdditional;
    this.employeeDayAdditionalReason = [];
    this.hourTypes = [];
    this.employeePortalMinDto = {
      nominations: [],
      useNominations: false
    };
  }

  public async created(): Promise<void> {
    this.isReady = false;
    await this.onGetEmployeePortalMin();
    await this.loadEmployeeDayAdditionalReasons();
    await this.loadHourTypes();
    this.isReady = true;
  }

  public async onDateChanged(value: any): Promise<void> {
    await this.onGetEmployeePortalMin();
  }

  public async onGetEmployeePortalMin(): Promise<void> {
    let dto = await store.dispatch(AppConstants.StoreActions.GetEmployeePortalMin, { date: this.drawerParams.date });
    if (dto == null) return;
    this.employeePortalMinDto = dto;
  }

  async onEditAdditional(additionalId) {
    await this.loadEmployeeDayAdditionalToEdit(additionalId);
    this.changeViewPage();
  }

  async changeViewPage() {
    if (this.editMode === "viewList") {
      this.editMode = "editItem";
    } else {
      this.model = new Models.EmployeeExtra();
      this.editMode = "viewList";
    }
  }

  loadEmployeeDayAdditionalToEdit(additionalId: number) {
    this.appEnv.isBusy = true;
    return apiService
      .getEmployeeDayAdditionalToEditData(additionalId)
      .then((res) => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          this.model = { ...call.callResult.data };
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
      })
      .finally(() => {
        this.appEnv.isBusy = false;
      });
  }

  loadEmployeeDayAdditionalReasons() {
    this.appEnv.isBusy = true;
    return apiService
      .getEmployeeDayAdditionalsReasonsPortalData(this.drawerParams.employeeId)
      .then((res) => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          this.employeeDayAdditionalReason = call.callResult.data;
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
      })
      .finally(() => {
        this.appEnv.isBusy = false;
      });
  }

  loadHourTypes() {
    return apiService
      .getBaseItem(AppConstants.BaseItems.HourType)
      .then((res) => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          this.hourTypes = this.getHourType(call.callResult.data);
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
      });
  }

  private getHourType(hourTypeArray) {
    return hourTypeArray.map((e) => {
      return { value: e.id, label: e.name };
    });
  }

  onCloseApprovalInfoDrawer() {
    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, false);
    store.commit(AppConstants.StoreMutations.UpdateLeftDrawerComponnent, null);
    store.commit(AppConstants.StoreMutations.UpdateDrawerParams, {});
    if (this.isCurrentUserAdditional && this.$route.name != AppConstants.Routes.E_PersonalArea && this.isCurrentUserAdditional && this.$route.name != AppConstants.Routes.M_PersonalArea) {
      return;
    }
    store.dispatch(AppConstants.StoreActions.GetEmployeeMonthAttendViewData);
  }

  get canEditMonth() {
    return store.getters.canEditMonth;
  }

  get drawerParams() {
    return store.getters.drawerParams;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
